<template>
    <div class="modal fade terms-condition inactivity" id="termsandcondition" tabindex="-1" role="dialog" aria-labelledby="termsandconditionLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content text-center">
            <div class="modal-body">
                <h5 class="modal-title">Please continue your booking over the phone. Thank you.</h5>
                <div class="contact-details m-3">
                    <div class="contact-details__number">
                        <div class="">
                            <span class="icon icon-phone"></span>
                            <span>Booking Phone No.</span>
                        </div>
                        <span> {{ contactDetails.contactNumber }} </span>
                    </div>
                    <div class="contact-details__operatinghrs">
                        <div class="">
                            <span class="icon icon-timeline"></span>
                            <span>Operating hours</span>
                        </div>
                        <span>{{ contactDetails.operatingHours }}</span>
                    </div>
                </div>
                <ColoredButton class="mt-3" data-dismiss="modal">OK</ColoredButton>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ColoredButton from './ColoredButton';
    export default {
        components: {
            ColoredButton
        },
        computed: {
            contactDetails() {
                return this.$store.getters['GET_FOOTER_SETTINGS']; 
            }
        },
        mounted() {
            this.$store.dispatch('footerSettings');
        }
    }
</script>